import toast from 'react-hot-toast';

import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';

const SKIP_ENDPOINTS: string[] = [];

export const rtkQueryErrorLogger: Middleware =
  () => (next) => (action: any) => {
    if (SKIP_ENDPOINTS.includes(action?.meta?.arg?.endpointName)) {
      return next(action);
    }

    if (isRejectedWithValue(action)) {
      if (action?.payload?.data?.reason) {
        toast.error(action?.payload?.data?.reason);
      }
    }

    return next(action);
  };
